var wooLogin = (function($){

    return {
        init : init
    }
    function init(){
        $(document).on('click', '.woocommerce-Login-wrapper__login-tab', function(e){
            e.preventDefault();
            $('.woocommerce-Login-wrapper__login-tab').removeClass('active');
            $('.woocommerce-Login-wrapper__item').removeClass('active');
            
            $(this).addClass('active');

            let idTarget = $(this).data('target');
            $('#'+idTarget).addClass('active');
        })
    }
})(jQuery);

wooLogin.init();